export const SERVICE_ERRORS = {
  CREATING_FILE: 'Sorry! Something went wrong creating the file',
};